__turbopack_context__.v({
  "searchContainer": "searchInput-module-scss-module__XisF2a__searchContainer",
});
